import router from "core/router";
import { Pages, Tabs } from "routeConstants";

export const getSellSwitchFormUrl = (idObject) => router.getStaticUrl(Pages.CONTRACT_DIRECT, Tabs.SELL_SWITCH_FORM, { idObject });
